<template>
  <Linear
    v-if="selectedvalue==='Linear'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <Quadratic
    v-else-if="selectedvalue==='Quadratic'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <InverseSqrRoot
    v-else-if="selectedvalue==='Inverse square root'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <SemilogX
    v-else-if="selectedvalue==='Semilog x'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <DoubleLog
    v-else-if="selectedvalue==='Double log'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <!-- <<SemilogY
    v-else-if="selectedvalue==='Semilog y'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <ExponentialX
    v-else-if="selectedvalue==='Exponential x'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <ExponentialY
    v-else-if="selectedvalue==='Exponential y'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  />
  <MichaelisMenten
    v-else-if="selectedvalue==='Michaelis-Menten'"
    :sectionconfig="sectionconfig"
    :fitname="fitname"
  /> -->
</template>

<script>
import Linear from './Linear'
import Quadratic from './Quadratic'
import InverseSqrRoot from './InverseSqrRoot'
import SemilogX from './SemilogX'
//import SemilogY from './SemilogY'
import DoubleLog from './DoubleLog'
//import ExponentialX from './ExponentialX'
//import ExponentialY from './ExponentialY'
//import MichaelisMenten from './MichaelisMenten'
export default {
  name: 'SelectedFit',
  components:{
    Linear,
    Quadratic,
    InverseSqrRoot,
    SemilogX,
    //SemilogY,
    DoubleLog,
    //ExponentialX,
    //ExponentialY,
    //MichaelisMenten
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    },
    selectedvalue:{
      type:String,
      required:true
    },
    fitname:{
      type:String,
      required:true
    }
  }
}
</script>

<style>

</style>